<script lang="ts">
  import { goto } from "$app/navigation";
  import { auth } from "$lib/stores/auth.svelte";
  import type { LayoutProps } from "./$types";

  if (auth.user?.role !== 'instructor') {
    goto('/', {replaceState: true});
  }

  let { children }: LayoutProps = $props();
</script>

{@render children?.()}